import * as React from "react";
const SvgEyeOff = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M8.057 3.82q.458-.07.943-.07c3.83 0 6.342 3.379 7.186 4.715.102.162.153.243.181.367a.9.9 0 0 1 0 .336c-.028.124-.08.206-.183.369-.225.356-.567.856-1.022 1.398M5.043 5.036c-1.621 1.1-2.722 2.629-3.227 3.428-.103.162-.154.244-.183.368a.9.9 0 0 0 0 .336c.029.124.08.205.182.367C2.66 10.87 5.172 14.25 9 14.25c1.544 0 2.874-.55 3.967-1.293M2.25 2.25l13.5 13.5M7.41 7.409a2.25 2.25 0 1 0 3.182 3.182"
    />
  </svg>
);
export default SvgEyeOff;
